export const ModuleContext = "context";
export const ModuleLayoutTemplate = "layoutTemplate";
export const ModuleOrganization = "organization";
export const ModuleUserManager = "userManager";
export const ModuleRole = "role";
export const ModuleRoleApplication = "roleApplication";
export const ModuleRoleApplicationDetail = "roleApplicationDetail";
export const ModuleUserRole = "userRole";
export const ModuleLocation = "location";
export const ModuleTenant = "tenant";
export const ModuleDepartment = "department";
export const ModuleJobTitle = "jobTitle";
export const ModuleEmployee = "employee";
export const ModuleNotification = "notification";

/**
 * Danh sách module của chương trình
 */
export const AppModules = [
  ModuleTenant,
  ModuleContext,
  ModuleLayoutTemplate,
  ModuleOrganization,
  ModuleUserManager,
  ModuleRole,
  ModuleRoleApplication,
  ModuleRoleApplicationDetail,
  ModuleUserRole,
  ModuleLocation,
  ModuleDepartment,
  ModuleJobTitle,
  ModuleEmployee,
  ModuleNotification
];